<script>
console.clear();
import { canEditAttendanceMoneyFields } from "@/helpers/userPermissions"
import { resolveCodeTaxId } from "@/helpers/attendance-code-tax"
import { notificationMethods } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

export default {
  props: {
    currentUser: { type: Object, required: true },
    currentEmpresa: {type: Object, required: true,},
    listAgreements: { type: Array },
    listApproachs: { type: Array },
    listCodesTaxs: { type: Array, required: true },
    listPacients: { type: Array },
    listPrices: { type: Array, required: true },
    listProfessionals: { type: Array },
    listResponsibles: { type: Array },
    listSpecialties: { type: Array },
    tiposPagamento: { type: Array }
  },
  components: {Multiselect},
  data() {
    return {
      listAggrenments: [],
      convenios:[],
      responsaveis:[],
      abordagens:[],
      tratamentos:[],
      pacientes: [],
      pacient: {},
      profissionais: [],
      tiposDePagamento: [],
      loader: {
        get: false,
      },
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Atendimentos",
          href: "/atendimentos",
          active: true,
        },
      ],
      titleBody: "Inserindo",
      inserindo: true,
      submitted: false,
      service: {
        service_value: 0,
        transfer_amount: 0,
        coparticipation_amount: 0,
        tipo_pagamento: null,
        tipo_pagamento_id: null,
        pacient: null,
        pacient_id: null,
        professional: null,
        agreement_id: null, // convêcnio (Unimed, SulAmerica)
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        recurrence: null,
        responsible_id: null,
        contact: null,
        treatment: null,
        approach: null,
        local: null,
        code_tax_id: null,
      },
      listRecurrence: [
        { id: 1, type: "none", name: "Nunca" },
        // { id: 2, type: "DAILY", name: "Diário" },
        { id: 3, type: "WEEKLY", name: "Semanal" },
        // { id: 4, type: "MONTHLY", name: "Mensal" },
        // { id: 4, type: "YEARLY", name: "Anual" },
      ],
      selectedTratament: null,
      selectedAgreement: null,
      selectedTipoPagamento: null,
    };
  },
  created() {
    this.profissionais   = this.listProfessionals
    this.pacientes       = this.listPacients
    this.tratamentos     = this.listSpecialties
    this.responsaveis    = this.listResponsibles
    this.abordagens      = this.listAbordagens
    this.convenios       = this.listAgreements
    this.codestax        = this.listCodesTaxs
    this.listAggrenments = this.convenios
    this.tiposDePagamento = this.tiposPagamento
  },
  validations() {
    return {
      service: {
        service_value: { required },
        treatment_id: { required },
        approach_id: { required },
        agreement_id: { required },
        pacient_id: { required },
        professional_id: { required },
        start_date: { required },
        start_time: { required },
        responsible_id: { required },
      },
    };
  },
  mounted() {
    this.$emit("newTitle", "Incluir Atendimento")
    this.pacient.empresa_id = this.currentEmpresa.id;
    this.selectedTratament = this.tratamentos.find((item) => {
      return item.id == this.service.treatment_id
    })
    this.selectedAgreement = this.convenios.find((item) => {
      return item.id == this.service.agreement_id
    })
  },
  computed: {
    permission() {
      return canEditAttendanceMoneyFields(this.currentUser)
    },
    isPrivate() {
      return this.service.pacient ? this.service.pacient.is_private : null
    },
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    getCidadeId(objects, key) {
      return objects.map(function (object) {
        return object[key];
      });
    },
  },
  methods: {
    ...notificationMethods,
    makeToast(variant = null, message = "Error generic") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    onPacientSelected(event) {
      this.service.responsible_id = event.responsible.id
      this.service.pacient_id = event.id
      this.service.pacient = event
      const convenios = this.listAggrenments.filter(agreement => agreement.is_private === this.service.pacient.is_private)
      this.convenios = convenios
    },
    onProfessionalSelected(event) {
      this.service.professional_id = event.id;
      this.service.professional = event;
      this.tratamentos = event.specialty;
    },
    onTipoPagamentoSelecionado(tipoPagamento) {
      // Verificação de segurança + atribuição limpa
      this.service.tipo_pagamento_id = tipoPagamento?.id || null
      this.selectedTipoPagamento     = (tipoPagamento) ? tipoPagamento : null
      this.service.tipo_pagamento    = tipoPagamento
    },
    onTratamentSelected(tratament) {
      this.service.treatment_id = tratament?.id || null
      this.selectedTratament = tratament || null
      this.applyCodeTaxFromSelections()
      this.setPrice()
    },
    onAgreementSelected(agreement) {
      this.service.agreement_id = agreement?.id || null
      this.selectedAgreement = agreement || null
      this.applyCodeTaxFromSelections()
      this.setPrice()
    },
    applyCodeTaxFromSelections() {
      this.service.code_tax_id = resolveCodeTaxId({
        agreement: this.selectedAgreement,
        specialty: this.selectedTratament,
      })
    },
    // eslint-disable-next-line no-unused-vars
    formSubmit(e) {
      this.submitted = true;
      this.setPost();
    },
    setPost() {
      this.$emit(
        "doPost",
        {
          service_value: this.new_convert_srting_float(this.service.service_value),
          transfer_amount: this.new_convert_srting_float(this.service.transfer_amount),
          coparticipation_amount: this.new_convert_srting_float(this.service.coparticipation_amount),
          contact: this.service.contact,
          local: this.service.local,
          treatment_id: this.service.treatment_id,
          approach_id: this.service.approach_id,
          responsible_id: this.service.responsible_id,
          agreement_id: this.service.agreement_id,
          pacient_id: this.service.pacient_id,
          professional_id: this.service.professional_id,
          empresa_id: this.currentEmpresa.id,
          start_date: this.service.start_date,
          end_date: this.service.end_date,
          start_time: this.service.start_time,
          end_time: this.service.end_time,
          recurrence: this.service.recurrence,
          specialty_id: this.service.specialty_id,
          code_tax_id: this.service.code_tax_id,
          tipo_pagamento_id: this.service.tipo_pagamento_id,
        }
      )
    },
    back() {
      this.$emit("back");
    },
    changeLoader(value) {
      this.loader.get = value;
    },
    setPrice() {
      // Aplicar o preço filtrando tratamento e convênio
      if (this.service.treatment_id && this.service.agreement_id) {
        let price = this.listPrices.filter((item) => {
          return (
            item.specialty_id == this.service.treatment_id &&
            item.agreement_id == this.service.agreement_id
          );
        });

        if (price.length > 0) {
          this.service.service_value   = this.formatterFloatBR(price[0].service_value)
          this.service.transfer_amount = this.formatterFloatBR(price[0].transfer_amount)
        }
      }
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <form @submit.prevent="formSubmit" name="formAtendimento">
        <div class="form-row col-md-12 mt-4">
          <div class="form-group col-md-4">
            <label for="nome">Paciente:</label>
            <Multiselect
              id="selectPacient"
              v-model="service.pacient"
              @select="onPacientSelected($event)"
              :options="pacientes"
              label="nome"
              track-by="id"
              deselect-label="ENTER para remover"
              select-label="Enter para selecionar"
              placeholder="Selecione"
            >
              <template #option="props">
                {{ props.option.id }} - {{ props.option.nome }}
              </template>
            </Multiselect>
          </div>
          <div class="form-group col-md-4">
            <label for="agreement_id">Convênio:</label>
            <Multiselect 
              v-model="selectedAgreement"
              :options="convenios"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="true"
              :show-labels="false"
              placeholder="Selecione o convênio"
              label="name"
              track-by="id"
              @input="onAgreementSelected">
            </Multiselect>
          </div>
          <div class="form-group col-sm-6 col-md-4">
            <label for="selectAtendimentoProfessional">Profissional:</label>
            <Multiselect
              id="selectPacient"
              v-model="service.professional"
              @select="onProfessionalSelected($event)"
              :options="profissionais"
              label="name"
              track-by="id"
              deselect-label="ENTER para remover"
              select-label="Enter para selecionar"
              placeholder="Selecione"
            >
               <template #option="props">
                  {{ props.option.id }} - {{ props.option.name }}
              </template>
            </Multiselect>
          </div>
        </div>
        <div class="form-row col-md-12 mt-4">
          <div class="form-group col-md-6">
            <label for="selectAtendimentoTreatment">Tratamento:</label>
            <Multiselect
              v-model="selectedTratament"
              :options="tratamentos"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="true"
              :show-labels="false"
              placeholder="Selecione o tratamento"
              label="name"
              track-by="id"
              @input="onTratamentSelected"
            >
            </Multiselect>
          </div>
          <div class="form-group col-md-6">
            <label for="selectAtendimentoApproach">Abordagem:</label>
            <select
              class="custom-select mr-sm-2"
              id="selectApproach"
              v-model="service.approach_id"
            >
              <option value="-1" selected="selected">
                Selecione a abordagem
              </option>
              <option
                v-for="(item, index) in abordagens"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-row col-md-12 mt-4">
          <div class="form-group col-md-4">
            <label for="code_tax_id">Código Fiscal do Serviço:</label>
            <select
              v-model="service.code_tax_id"
              class="form-control"
              id="code_tax_id"
            >
              <option value="" selected>
                Selecione o código
              </option>
              <option
                v-for="codetax in codestax"
                :key="codetax.id"
                :value="codetax.id"
              >
              {{ codetax.id }} - {{ codetax.name }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <label for="localAtendimento">Local do atendimento:</label>
            <input
              id="localatendimento"
              type="text"
              class="form-control"
              placeholder="Local de atendimento"
              v-model="service.local"
            />
          </div>
          <div class="form-group col-md-2" v-show="permission || isPrivate">
            <label for="service_value">Valor do atendimento:</label>
            <input
              id="service_value"
              type="text"
              class="form-control text-right"
              placeholder="Ex: 70"
              v-model="service.service_value"
              @input="formatInputFloat($event,service,'service_value')"
            />
          </div>
          <div class="form-group col-md-2" v-show="permission || isPrivate">
            <label for="coparticipation_amount">Valor Coparticipação:</label>
            <input
              id="coparticipation_amount"
              type="text"
              class="form-control text-right"
              placeholder="Digite o valor"
              v-model="service.coparticipation_amount"
              @input="formatInputFloat($event,service,'coparticipation_amount')"
            />
          </div>
          <div class="form-group col-md-2" v-show="permission">
            <label for="transfer_amount">Valor do repasse:</label>
            <input
              id="transfer_amount"
              type="text"
              class="form-control text-right"
              placeholder="0,00"
              v-model="service.transfer_amount"
              @input="formatInputFloat($event, service, 'transfer_amount')"
            />
          </div>
        </div>
        <div class="form-row col-md-12 mt-4">
          <h4 class="card-title col-md-12">Período recorrência</h4>
          <p class="col-md-12">Defina o período de recorrência do Atendimento</p>
          <div class="form-group col-md-2">
            <label for="end_hour">Tipo de recorrência:</label>
            <select
              class="custom-select mr-sm-2"
              id="selectRecurrence"
              v-model="service.recurrence"
            >
              <option v-for="recurrence in listRecurrence" :key="recurrence.id" :value="recurrence.type">{{ recurrence.name }}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="start_date">Data início:</label>
            <input
              name="start_date"
              type="date"
              class="form-control"
              required
              v-model="service.start_date"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="start_time">Hora início:</label>
            <input
              name="start_time"
              type="time"
              class="form-control"
              required
              v-model="service.start_time"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="end_time">Hora fim:</label>
            <input
              name="end_time"
              type="time"
              class="form-control"
              v-model="service.end_time"
            />
          </div>
          <div class="form-group col-md-3">
            <label for="end_date">Data fim:</label>
            <input
              name="end_date"
              type="date"
              class="form-control"
              v-model="service.end_date"
            />
          </div>
        </div>

        <div class="form-row mt-4" v-if="isPrivate">
          <div class="col-md-4">
            <label for="tipo_pagamento_id">Tipo Pagamento</label>
            <Multiselect
              :options="tiposDePagamento"
              v-model="selectedTipoPagamento"
              @input="onTipoPagamentoSelecionado"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :track-by="'id'"
              :label="'tiponome'"
              deselect-label="ENTER para remover"
              select-label="Enter para selecionar"
              placeholder="Selecione"
            ></Multiselect>
          </div>
        </div>
        <div class="form-row col-md-12 mt-4">
          <div class="col-md-12 mt-4">
            <button
                type="button"
                class="btn btn-warning"
                style="margin-right: 20px"
                @click="back()"
              >
                <i class="ri-close-line align-middle mr-2"></i> Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-success"
              style="margin-right: 20px"
              @click.prevent="setPost()"
            >
              <i class="ri-check-line align-middle mr-2"></i> Cadastrar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>